import React, { lazy, Suspense } from 'react';
import Loader from '../../components/Loader/Loader.lazy';

const LazyUserHome = lazy(() => import('./UserHome'));

const UserHome = (props) => (
  <Suspense fallback={<Loader />}>
    <LazyUserHome {...props} />
  </Suspense>
);

export default UserHome;
